
export default {
  props: {
    isline: {
      // 是否折行样式
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hotdata: []
    }
  },
  mounted() {
    this.getdata()
  },
  methods: {
    getdata() {
      // this.sensorTrackHead(this.$route.name, 'focus')
      this.$api.home
        .invokev3(
          {},
          {
            Routes: 'search$statisticsHotSearch'
          }
        )
        .then((res) => {
          const arr = res.search.statisticshotsearch.data ? res.search.statisticshotsearch.data : []
          // const articletime = new Date().getTime() - new Date('2023-9-28 23:59:59').getTime()
          // if (articletime < 0 && (this.$store.state.CountryCode == 'cn' || this.$store.state.CountryCode == 'hk')) {
          //   if (arr.length >= 6) arr.pop()
          //   arr.push({
          //     code: '2277676718',
          //     showName: this.$store.state.LanguageCode == 'zh-cn' ? 'STARTRADER 星迈' : 'STARTRADER'
          //   })
          // }
          this.hotdata = [...arr]
        })
    },
    todealer(item) {
      this.$api.home
        .invokev3(
          {
            code: item.code,
            keyword: item.showName,
            url: this.$store.state.allHost,
            userAgent: navigator.userAgent,
            userId: this.$store.state.user.userId ? this.$store.state.user.userId : this.$Cookie.get('wiki-bfp')
          },
          {
            Routes: 'search$statisticsupload'
          }
        )
        .then((res) => {
          console.log(res, 11123)
        })
      window.open(`${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${item.code}.html`)
    }
  }
}
